import React from 'react';
import { Box, Typography } from '@mui/material';
import { SectionCard } from '../../../../components/ui';
import { brandHome } from '../../brandHomeTokens';

export interface ActivityRow {
  id: string;
  tag: string;
  tagBg: string;
  tagInk: string;
  text: string;
  when: string;
}

interface BrandActivityCardProps {
  rows: ActivityRow[];
}

/** Renders nothing at all when there is no activity — no empty-state void. */
export const BrandActivityCard: React.FC<BrandActivityCardProps> = ({ rows }) => {
  if (rows.length === 0) return null;

  return (
    <SectionCard dense title="Brand activity">
      {rows.map((row) => (
        <Box key={row.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px', p: '11px 18px', borderBottom: `1px solid ${brandHome.color.rowHairline}` }}>
          <Box component="span" sx={{ px: '8px', py: '2px', borderRadius: `${brandHome.radius.chip}px`, bgcolor: row.tagBg, color: row.tagInk, fontSize: '11px', fontWeight: 700, flex: '0 0 auto' }}>
            {row.tag}
          </Box>
          <Typography sx={{ fontSize: '12.5px', color: brandHome.color.body, minWidth: 0 }}>{row.text}</Typography>
          <Typography sx={{ ml: 'auto', fontSize: '11.5px', color: brandHome.color.faint, flex: '0 0 auto' }}>{row.when}</Typography>
        </Box>
      ))}
    </SectionCard>
  );
};
